
import { defineComponent } from 'vue';
import ButtonRound from './ButtonRound.vue';

export default defineComponent({
	name: 'Pagination',
	components: {
		ButtonRound
	},
	props: {
		currentPage: { type: Number, required: true },
		pageCount: { type: Number, required: true },
		arrowPagination: { type: Boolean, default: false }
	}
});
